export default "__VITE_ASSET__CZzG6oA2__"